import { Pipe, PipeTransform } from '@angular/core';
import { Shop } from '@app/services/shops/shop.model';
import { Address } from '@app/sharedModule/models/address.model';
import { DAY } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Pipe({
  name: 'dayToDisplayName',
  standalone: false,
})
export class DayToDisplayNamePipe implements PipeTransform {
  transform(day: DAY): any {
    const daysMap = {
      [DAY.SUNDAY]: 'Sun',
      [DAY.MONDAY]: 'Mon',
      [DAY.TUESDAY]: 'Tue',
      [DAY.WEDNESDAY]: 'Wed',
      [DAY.THURSDAY]: 'Thu',
      [DAY.FRIDAY]: 'Fri',
      [DAY.SATURDAY]: 'Sat',
    };
    return daysMap[day];
  }
}

@Pipe({
  name: 'shopLocationOptions',
  standalone: false,
})
export class ShopLocationsOptions implements PipeTransform {
  transform(locations: Address[], isPrimary?: boolean): any {
    const generateLocationLabel = (address: Address) => {
      const { address1, address2, province, city, zip, country } = address;
      return `${address1 ?? ''} ${address2 ?? ''} ${province ?? ''} ${city ?? ''} ${zip ?? ''} ${country ?? ''}`;
    };

    const addresses = [];
    if (isPrimary) {
      const primaryLocation = locations.find((l) => !!l.isPrimaryLocation);
      const locationStr = generateLocationLabel(primaryLocation);
      return { label: locationStr, value: primaryLocation.id };
    }

    locations.forEach((l) => {
      const locationLabel = generateLocationLabel(l);
      addresses.push({ label: locationLabel, value: l.id });
    });
    return addresses;
  }
}

@Pipe({
  name: 'toAdditionalDisplayLabelText',
  standalone: false,
})
export class AdditionalDisplayLabelText implements PipeTransform {
  transform(type: string): string {
    let labelText = '';
    if (type === 'product-type') {
      labelText = 'product type';
    } else if (type === 'vendor') {
      labelText = 'vendor';
    }
    return labelText;
  }
}

@Pipe({
  name: 'autocompleteShippingMethodsNames',
  standalone: false,
})
export class AutocompleteShippingMethodsNamesPipe implements PipeTransform {
  transform(shippingMethods: any[]): { name: string }[] {
    return shippingMethods.map((method) => method.name).filter(Boolean);
  }
}

@Pipe({
  name: 'shopCheckoutEditorUrl',
  standalone: false,
})
export class ShopCheckoutEditorUrlPipe implements PipeTransform {
  transform(shop: Shop): string {
    return `https://${shop.name}/admin/themes/current/editor`;
  }
}
